import { motion } from 'framer-motion';

const restaurantImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/9mflczp9_Restaurant-Hallbergmoos-Italiener-27.jpg",
    alt: "Restaurant Il Girasole Innenansicht"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/detarmam_Restaurant-Hallbergmoos-Italiener-34.jpg",
    alt: "Restaurant Il Girasole Ambiente"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/sj8cxn6o_Restaurant-Hallbergmoos-Italiener-25.jpg",
    alt: "Restaurant Il Girasole Tische"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/8gmpbwlu_Restaurant-Hallbergmoos-Italiener-74.jpg",
    alt: "Restaurant Il Girasole Laterne"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/144kyrgs_Restaurant-Hallbergmoos-Italiener-69.jpg",
    alt: "Restaurant Il Girasole Dekoration"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_trattoria-girasole/artifacts/cp5q40au_Restaurant-Hallbergmoos-Italiener-31.jpg",
    alt: "Restaurant Il Girasole Venedig"
  }
];

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${restaurantImages[0].url}')`
          }}
        />
        <div className="absolute inset-0 bg-olive-900/60" />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 text-center px-4"
        >
          <p className="font-accent text-gold text-2xl mb-4">Chi Siamo</p>
          <h1 className="font-heading text-5xl md:text-6xl text-cream">Über uns</h1>
        </motion.div>
      </section>

      {/* Welcome Message Section */}
      <section data-testid="welcome-section" className="py-24 md:py-32 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <p className="font-accent text-terracotta text-2xl mb-4">Liebe Gäste</p>
              <div className="space-y-6 font-body text-muted-foreground text-lg leading-relaxed">
                <p>
                  Wir betrachten es als unsere größte Pflicht, all die Gaben, die uns die Natur 
                  in so reicher Masse zur Verfügung stellt, zu nutzen und nach bestem 
                  gastronomischen Wissen zuzubereiten.
                </p>
                <p>
                  Wir hoffen, auch Ihren Geschmack getroffen zu haben.
                </p>
                <p>
                  Als Freunde des Hauses möchten wir Sie stets zuvorkommend bedienen und 
                  wünschen Ihnen einen angenehmen Aufenthalt.
                </p>
              </div>
              <div className="mt-8">
                <p className="font-accent text-olive-900 text-xl">
                  Ihr Il Girasole Team
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <div className="border-[8px] border-cream-dark p-2 shadow-xl">
                <img
                  src={restaurantImages[1].url}
                  alt={restaurantImages[1].alt}
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section data-testid="gallery-section" className="py-24 md:py-32 bg-cream-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-accent text-terracotta text-xl mb-2">Impressionen</p>
            <h2 className="font-heading text-4xl md:text-5xl text-olive-900">
              Unser Restaurant
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {restaurantImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`gallery-image-${index}`}
                className="group overflow-hidden bg-white shadow-[0_4px_20px_-2px_rgba(0,0,0,0.1)] hover:shadow-lg transition-shadow duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-24 md:py-32 bg-olive-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-accent text-gold text-6xl mb-6">"</p>
            <blockquote className="font-heading text-3xl md:text-4xl text-cream italic leading-relaxed mb-8">
              La cucina è l'arte di trasformare ingredienti semplici in momenti indimenticabili.
            </blockquote>
            <p className="font-body text-cream/70 text-lg">
              – Die Kunst, einfache Zutaten in unvergessliche Momente zu verwandeln.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
